/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @最后编辑: Betway
 * @最后修改时间: 2023-06-07 18:35:04
 */
//导入文件
import http from "../httpConfig"
import store from "@/store"
import AWSS3 from "@/utils/awss3" //AWS S3
//换了接口需要将接口加在httpConfig.js的白名单中
//新增导入的接口需要加在httpConfig.js的白名单中
// /api/importData/international-import-data/{version} 通用导入
// /api/importData/user-import-data/v1 用户信息导入
// /api/importData/org-import-data/v1 组织机构导入
//导入文件  通用导入改---国际化导入
export const uploadFileAll = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/international-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
//导入文件  用户property导入
export const uploadStaffProperty = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/staff-property/import/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
//导入文件  用户信息导入
export const uploadFileUser = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/user-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  成本中心导入
export const uploadFileCostCenter = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/common-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  组织机构导入
export const uploadFileOrg = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/org-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  岗位等级导入
export const uploadFilePostGrade = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/postGrade-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  员工等级和员工类型和员工关系共用导入
export const uploadStaffGradeAndStaffType = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/common-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  员工关系配置导入
export const uploadStaffRelationConfig = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/staff-correlation-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  岗位导入
export const uploadFilePost = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/importData/post-import-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//导入文件  代理申请配置
export const uploadOnBehalfApplicationConfig = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadFile("/api/operation_replace/import/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//下载错误文件信息
export const uploadError = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .uploadError("/api/importData/import-errorInfo-download/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//查询上传文件信息地址
export const findSrc = (params = {}) => {
  params["~table~"] = "mrbase_sys_attachments"
  let upload_type = store.state.sys_upload_type
  return new Promise((resolve, reject) => {
    http
      .post("/api/awsS3FileManager/get-file-info/v1", params)
      .then(async (res) => {
        res = Object.assign(res, {
          data: {
            files: res.data.files.map((item) => {
              return {
                ...item,
                path: AWSS3.sign(item.path),
              }
            }),
          },
        })
        if (upload_type["file_upload_method"] == "local") {
          let fns = [] //Promise对象集合
          res.data.files.forEach((item, index) => {
            fns.push(
              new Promise((c_resolve, c_reject) => {
                http
                  .post(
                    item.path,
                    {
                      files: [item],
                    },
                    {
                      responseType: "blob",
                    },
                  )
                  .then((c_res) => {
                    var blob = new Blob([c_res], { type: c_res.type })
                    var path = window.URL.createObjectURL(blob)
                    c_resolve({
                      code: "200",
                      data: {
                        ...item,
                        path: path,
                      },
                      msg: "成功",
                      status: "success",
                    })
                  })
                  .catch((err) => {
                    c_reject(err)
                  })
              }),
            )
          })
          Promise.all(fns)
            .then((result) => {
              let files = result.map((item) => {
                return item.data
              })
              resolve({
                code: "200",
                data: {
                  files: files,
                  sastoken: "",
                },
                msg: "成功",
                status: "success",
              })
            })
            .catch((err) => {
              reject({
                code: "400",
                data: {
                  files: [],
                  sastoken: "",
                },
                msg: "失败",
              })
            })
        } else {
          resolve(res)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
